// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/sticky/index.css
// module id = 185
// module chunks = 1